import React from "react";
import PropTypes from "prop-types";
import ApplicationSelect from "../Application/ApplicationSelect";
import apiUser from "../../apiUser";
import {useTranslation} from "react-i18next";

function WorkshopProductPriceGroupSelect(props){
  const { t } = useTranslation('workshop_product_price_group_select');

  return <ApplicationSelect
    id={'workshopProductPriceGroup-tooltip'}
    fetchById={apiUser.workshopProductPriceGroups.get}
    isSearchable={false}
    isClearable={false}
    placeholder={t('placeholder')}
    searchData={apiUser.workshopProductPriceGroups.search}
    sortField={'ppg.markup'}
    sortOrder={'desc'}
    value={props?.workshopProductPriceGroup?.id}
    onChange={entity => props.onChange(entity)}
    tooltip={props.tooltip ? t('placeholder') : undefined}
  />
}

WorkshopProductPriceGroupSelect.defaultProps = {
  tooltip: false,
};

WorkshopProductPriceGroupSelect.propTypes = {
  tooltip: PropTypes.bool,
  workshopProductPriceGroup: PropTypes.shape({
    id: PropTypes.number,
  }),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default WorkshopProductPriceGroupSelect;